import type { ButtonProps } from '@mui/material/Button';

import { useCallback } from 'react';
import { useNavigate } from 'react-router';

import Button from '@mui/material/Button';

import { paths } from 'src/routes/paths';

import { CONFIG } from 'src/global-config';

import { useAuthContext } from 'src/auth/hooks';
import { signOut } from 'src/auth/context/jwt/action';

type Props = ButtonProps & {
  onClose?: () => void;
};

export function SignOutButton({ onClose, sx, ...other }: Props) {
  const { checkUserSession } = useAuthContext();
  const navigate = useNavigate();

  const handleLogout = useCallback(async () => {
    try {
      await signOut();
      await checkUserSession?.();

      onClose?.();
      if (!import.meta.env.DEV) {
        window.location.replace(CONFIG.externalLoginUrl);
      } else {
        navigate(paths.auth.signIn);
      }
    } catch (error) {
      console.error(error);
    }
  }, [checkUserSession, onClose, navigate]);

  return (
    <Button
      fullWidth
      variant="soft"
      size="large"
      color="error"
      onClick={handleLogout}
      sx={sx}
      {...other}
    >
      Logout
    </Button>
  );
}
